import { __TypeOfOrderEnum } from '../initial/initial.interface';
import { __SellDepositConvertBoxProps } from './sellDeposit.interface';
import { __ConvertBoxConfirmOrderDetailModalRef } from '../confirmOrderModal/orderDetailModal.interface';
import SellCryptoDeposit from './crypto/sellCryptoDeposit.index';
import SellUUSDDeposit from './uusd/sellUUSDDeposit.index';

const SellDeposit: React.FC<__SellDepositConvertBoxProps> = (props: __SellDepositConvertBoxProps) => {
    return (
        <>
            {props.data?.srcCoin?.symbol === 'UUSD' ? (
                <>
                    <SellUUSDDeposit onBack={props.onBack} data={props.data} onFinish={props.onFinish} />
                </>
            ) : (
                <SellCryptoDeposit onBack={props.onBack} data={props.data} onSubmit={props.onSubmit} />
            )}
        </>
    );
};
export default SellDeposit;
